import { AttachmentProps } from '@/models/Attachment';
import { EventProps } from '@/models/Event';
import { EventTypeProps } from '@/models/EventType';

// Whether a single event has everything its event type requires. `files` is undefined
// when the caller doesn't yet know the application answer's attachments (e.g. before
// the question's answer has loaded) - only treated as "not ready" when the event type
// actually requires proof, so events for types with no proof requirement aren't blocked
// from ever validating just because no answer/attachment record exists yet.
export const isEventValid = (
  event: EventProps,
  config: EventTypeProps | null,
  files: AttachmentProps[] | undefined
): boolean => {
  if (config == null) return false;
  if (config.displayProof && files == null) return false;

  // Check if the event date is present
  if (event.eventDate == null || event.eventDate === '') return false;

  // Check if the description is required and present
  if (config.displayDescription && (event.description == null || event.description === '')) {
    return false;
  }

  // Check if the number of participants is required and present
  if (config.displayNumParticipants && event.numParticipants == null) return false;

  // Check if the event subtype is required and present
  if (config.displayEventSubType && event.eventSubTypeId == null) return false;

  // Check if the event name is required and present
  if (config.displayName && (event.eventName == null || event.eventName === '')) return false;

  // Check if proof is required and present
  if (config.displayProof && !(files ?? []).some((x: AttachmentProps) => x.eventId == event.id)) {
    return false;
  }

  return true;
};
